export default __webpack_public_path__ + "static/icon-2853f7e29f6aaae1e688e6c2bc923623.png";